import { render, staticRenderFns } from "./authority.vue?vue&type=template&id=50ba2991&scoped=true&"
import script from "./authority.vue?vue&type=script&lang=js&"
export * from "./authority.vue?vue&type=script&lang=js&"
import style0 from "./authority.vue?vue&type=style&index=0&id=50ba2991&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ba2991",
  null
  
)

export default component.exports